

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../static/Courses.css";

const courseData = [
  {
    id: 1,
    title: "Java Full Stack Development",
    category: "Development",
    level: "Beginner",
    instructor: "Rahul Sharma",
    rating: 4.8,
    price: "₹4,999"
  },
  {
    id: 2,
    title: "Spring Boot & Microservices",
    category: "Development",
    level: "Intermediate",
    instructor: "Priya Verma",
    rating: 4.7,
    price: "₹5,499"
  },
  {
    id: 3,
    title: "React JS Masterclass",
    category: "Development",
    level: "Intermediate",
    instructor: "Sneha Reddy",
    rating: 4.8,
    price: "₹3,999"
  },
  {
    id: 4,
    title: "Node.js & Express Backend",
    category: "Development",
    level: "Intermediate",
    instructor: "Arjun Mehta",
    rating: 4.6,
    price: "₹3,499"
  },
  {
    id: 5,
    title: "Python Programming Complete Guide",
    category: "Programming",
    level: "Beginner",
    instructor: "Anil Kumar",
    rating: 4.9,
    price: "₹2,999"
  },
  {
    id: 6,
    title: "Data Structures & Algorithms",
    category: "Programming",
    level: "Intermediate",
    instructor: "Vikram Rao",
    rating: 4.8,
    price: "₹3,999"
  },
  {
    id: 7,
    title: "Artificial Intelligence Fundamentals",
    category: "AI",
    level: "Beginner",
    instructor: "Dr. Kiran",
    rating: 4.7,
    price: "₹5,999"
  },
  {
    id: 8,
    title: "Machine Learning with Python",
    category: "AI",
    level: "Advanced",
    instructor: "Sanjay Patel",
    rating: 4.9,
    price: "₹6,999"
  },
  {
    id: 9,
    title: "Deep Learning & Neural Networks",
    category: "AI",
    level: "Advanced",
    instructor: "Dr. Meera Iyer",
    rating: 4.8,
    price: "₹7,499"
  },
  {
    id: 10,
    title: "SQL & Database Management",
    category: "Database",
    level: "Beginner",
    instructor: "Naveen Reddy",
    rating: 4.6,
    price: "₹2,499"
  },
  {
    id: 11,
    title: "MongoDB & NoSQL Databases",
    category: "Database",
    level: "Intermediate",
    instructor: "Harsha Vardhan",
    rating: 4.5,
    price: "₹3,499"
  },
  {
    id: 12,
    title: "Cybersecurity Essentials",
    category: "Security",
    level: "Beginner",
    instructor: "Rohit Singh",
    rating: 4.7,
    price: "₹4,499"
  },
  {
    id: 13,
    title: "Ethical Hacking Masterclass",
    category: "Security",
    level: "Advanced",
    instructor: "Aditya Kapoor",
    rating: 4.8,
    price: "₹6,499"
  },
  {
    id: 14,
    title: "Cloud Computing with AWS",
    category: "Cloud",
    level: "Intermediate",
    instructor: "Suresh Babu",
    rating: 4.7,
    price: "₹5,999"
  },
  {
    id: 15,
    title: "Docker & Kubernetes",
    category: "Cloud",
    level: "Advanced",
    instructor: "Pooja Nair",
    rating: 4.8,
    price: "₹6,499"
  },
  {
    id: 16,
    title: "UI/UX Design Principles",
    category: "Design",
    level: "Beginner",
    instructor: "Divya Sharma",
    rating: 4.6,
    price: "₹2,999"
  },
  {
    id: 17,
    title: "Figma for Web Designers",
    category: "Design",
    level: "Beginner",
    instructor: "Neha Joshi",
    rating: 4.5,
    price: "₹2,499"
  },
  {
    id: 18,
    title: "DevOps Complete Bootcamp",
    category: "Cloud",
    level: "Advanced",
    instructor: "Manoj Kumar",
    rating: 4.9,
    price: "₹7,999"
  },
  {
    id: 19,
    title: "Full Stack Project Development",
    category: "Development",
    level: "Advanced",
    instructor: "Rakesh Verma",
    rating: 4.8,
    price: "₹8,999"
  },
  {
    id: 20,
    title: "Interview Preparation & Aptitude",
    category: "Career",
    level: "Beginner",
    instructor: "Lakshmi Prasad",
    rating: 4.7,
    price: "₹1,999"
  }
];

function Courses() {
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");
  const navigate = useNavigate();

  const filteredCourses = courseData.filter((course) => {
    return (
      (category === "All" || course.category === category) &&
      course.title.toLowerCase().includes(search.toLowerCase())
    );
  });

  // 🔥 ENROLL LOGIC
  const handleEnroll = (course) => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");

    if (!isLoggedIn) {
      alert("Please login to enroll 🚀");
      navigate("/login");
    } else {
      navigate("/enroll", { state: { course } });
    }
  };

  return (
    <div className="courses-wrapper">
      <h1 className="courses-title">Explore Our Courses</h1>

      {/* Search */}
      <input
        type="text"
        placeholder="Search courses..."
        className="search-bar"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {/* Category Filters */}
      <div className="category-filters">
        {["All", "Development", "AI", "Programming"].map((cat) => (
          <button
            key={cat}
            className={category === cat ? "active" : ""}
            onClick={() => setCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Course Cards */}
      <div className="courses-container">
        {filteredCourses.map((course) => (
          <div className="course-card" key={course.id}>
            <span className="level-badge">{course.level}</span>
            <h2>{course.title}</h2>
            <p>👨‍🏫 {course.instructor}</p>
            <p>⭐ {course.rating}</p>
            <p className="price">{course.price}</p>

            <button
              className="enroll-btn"
              onClick={() => handleEnroll(course)}
            >
              Enroll Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Courses;